import translations from '../../../config/translations';

export const LanguageActionTypes = {
  SET_LANGUAGE: 'SET_LANGUAGE',
};

const setLanguage = ({ lng }) => (dispatch) => translations.registration.changeLanguage(lng).then(() => dispatch({
  type: LanguageActionTypes.SET_LANGUAGE,
  payload: {
    lng,
  },
}));

export const LanguageActions = {
  setLanguage,
};
